import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ResqlyMark from './ResqlyMark';
import ResqlyCard from './ResqlyCard';

/**
 * Secondary Ranger discovery on Customer Home — quiet invitation, not a role selector.
 */
export default function RangerEntrySection() {
  const navigate = useNavigate();

  return (
    <section className="px-5 mt-8 mb-3" data-testid="home-ranger-section">
      <ResqlyCard
        className="p-4 bg-gradient-to-br from-slate-50/80 to-white border-slate-200/80"
        elevated={false}
      >
        <div className="flex items-start gap-3">
          <div
            className="flex-shrink-0 w-11 h-11 rounded-2xl bg-blue-50 border border-blue-100/80 flex items-center justify-center shadow-sm"
            aria-hidden="true"
          >
            <ResqlyMark size={28} />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-xs font-medium text-slate-500">Want to be there for someone?</p>
            <h3 className="text-base font-semibold text-slate-900 mt-0.5 tracking-tight">
              Join as a RESQLY Ranger
            </h3>
            <p className="text-sm text-slate-600 mt-1 leading-snug">
              Provide care through RESQLY as a verified service partner.
            </p>
            <button
              type="button"
              data-testid="home-ranger-link"
              onClick={() => navigate('/consumer/ranger')}
              className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-blue-700 hover:text-blue-800 active:scale-[0.98] transition-transform"
            >
              Join as Ranger
              <ArrowRight className="w-4 h-4" strokeWidth={2.2} />
            </button>
          </div>
        </div>
      </ResqlyCard>
    </section>
  );
}
